export const env = {
    produrl: "https://api.neovector.neoauralabs.com/api/v1",
    // produrl: "http://localhost:4000/api/v1",
}